// src/services/api.js
import axios from "axios";
import { getApiBase } from "../utils/apiBase";

const api = axios.create({
  baseURL: getApiBase(),
  withCredentials: true,
});

export default api;
